// extracted by mini-css-extract-plugin
export default {"profile_header":"Profile_profile_header__z3Y5G","title":"Profile_title__ckpkD"};